import React from "react";

const MapGeofenceSelectorLoadable = React.lazy(() => import("./MapGeofenceEditor"));

export { MapGeofenceSelectorLoadable };